import React from "react";

import { ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";
import { useSnapshot } from "valtio";
import { StyledBreadcrumb } from "@aureskonnect/react-ui";
import { getPathAuthorization } from "@components/VerticalLayout";
import { useLocation } from "react-router-dom";

import { store } from "@components/VerticalLayout/store";
import { setModify } from "./store";

import PageTitle from "@components/Common/PageTitle";
import MessageInfo from "@components/Common/MessageInfo";
import { MainColorTabsWrapper } from "@components/Common/MainColorTabsWrapper";
import ModeOfSales from "./ModeOfSales";
import ShopsModeOfSales from "./ShopsModeOfSales";
import { StyledTabs } from "./StyledTabs";

import "./index.css";

function LocalModeOfSale() {
    const location = useLocation();
    setModify(getPathAuthorization(location.pathname).Modifie);
    const { t } = useTranslation();
    const [isModeOfSaleArchived, setIsModeOfSaleArchived] = React.useState<
        boolean
    >(false);

    const { oneShop } = useSnapshot(store);
    const [limit, setLimit] = React.useState<number>(1);

    const tabs1 = (
        <ModeOfSales
            isModeOfSaleArchived={isModeOfSaleArchived}
            setIsModeOfSaleArchived={setIsModeOfSaleArchived}
            setLimit={setLimit}
        />
    );

    const tabs2 = (
        <StyledTabs
            tabs={[
                {
                    content: (
                        <ModeOfSales
                            isModeOfSaleArchived={isModeOfSaleArchived}
                            setIsModeOfSaleArchived={setIsModeOfSaleArchived}
                            setLimit={setLimit}
                        />
                    ),
                    disabled: false,
                    title: (
                        <div
                            className="d-flex justify-content-between text-dark cmn_btn_franchise"
                            style={{
                                gap: "10px",
                                font: "normal normal 600 16px/21px Segoe UI",
                            }}
                        >
                            {t("Sales method")}
                        </div>
                    ),
                },
                {
                    content: (
                        <ShopsModeOfSales
                            isModeOfSaleArchived={isModeOfSaleArchived}
                            setIsModeOfSaleArchived={setIsModeOfSaleArchived}
                            setLimit={setLimit}
                        />
                    ),
                    title: (
                        <div
                            className="d-flex justify-content-between text-dark border-0 cmn_btn_boutique"
                            style={{
                                gap: "10px",
                                font: "normal normal 600 16px/21px Segoe UI",
                            }}
                        >
                            {t("Sales method shops")}
                        </div>
                    ),
                },
            ]}
        />
    );

    return (
        <React.Fragment>
            <ToastContainer limit={limit} />
            <PageTitle title={t("General settings")} />
            <div className="page-content__clz">
                <div className="mdv_txt_modeOfSale">
                    <StyledBreadcrumb
                        items={[
                            {
                                item: "Settings".toUpperCase(),
                                link: `${process.env.REACT_APP_PORTAIL_URL}`,
                            },
                            {
                                item:
                                    localStorage
                                        .getItem("selectedAccount")
                                        ?.toUpperCase() || "",
                                link: oneShop
                                    ? "/setting/customer-account"
                                    : "/compte",
                            },
                            {
                                item: t("General settings").toUpperCase(),
                                link: "#",
                            },
                            {
                                item: !isModeOfSaleArchived
                                    ? t("Sales method").toUpperCase()
                                    : t("Archived sales method").toUpperCase(),
                                link: "#",
                            },
                        ]}
                    />
                </div>

                <MessageInfo
                    message={t(
                        "The various sales modes used by the store are configured in this section. It is important to note that the sales modes are configured by sales support."
                    )}
                />
                <MainColorTabsWrapper>
                    {oneShop ? tabs1 : tabs2}
                </MainColorTabsWrapper>
            </div>
        </React.Fragment>
    );
}

export const ModeOfSale = React.memo(LocalModeOfSale);
